import React from "react";
import "./ProductListToolbar.css";
import ProductListButton from "../../Button/ProductListButton";
import ProductFilterModal from "../ProductFilterModal/ProductFilterModal";
import LocationUpdateButton from "../ProductTable/LocationUpdateButton/LocationUpdateButton";
import { SaveChangesButton } from "../ProductTable/Utils/Utils";

const ProductListToolbar = ({
  isFilterOpen,
  setIsFilterOpen,
  handleRefresh,
  filters,
  setFilters,
  fields,
  dropdownData,
  onDownloadFiltered,
  searchQuery,
  setSearchQuery,
  selectedProducts,
  userEditable,
  currentProducts,
  setPendingChanges,
  user,
  pendingChanges,
  handleBulkUpdate,
}) => {
  return (
    <>
      <ProductFilterModal
        isOpen={isFilterOpen}
        onClose={() => setIsFilterOpen(false)}
        fields={fields}
        filters={filters}
        setFilters={setFilters}
        dropdownData={dropdownData}
        onDownloadFiltered={onDownloadFiltered}
      />
      <div className="entries-toolbar-container">
        <div className="entries-toolbar-Buttons">
          <ProductListButton
            label="Refresh"
            icon="fas fa-rotate-right"
            onClick={handleRefresh}
          />

          <ProductListButton
            label="Filter"
            icon="fas fa-filter"
            onClick={() => setIsFilterOpen(true)}
          />

          <LocationUpdateButton
            selectedProducts={selectedProducts}
            userEditable={userEditable}
            fields={fields}
            currentProducts={currentProducts}
            setPendingChanges={setPendingChanges}
            user={user}
          />

          {Object.keys(pendingChanges).length > 0 && (
            <SaveChangesButton onSave={handleBulkUpdate} />
          )}
        </div>
        <div className="toolbar-search-wrapper">
          <span className="toolbar-search-icon">
            <i className="fas fa-search"></i>
          </span>
          <input
            type="text"
            placeholder="Search here..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="toolbar-search-input"
          />
        </div>
      </div>
    </>
  );
};

export default ProductListToolbar;
